import { render, staticRenderFns } from "./Generated.vue?vue&type=template&id=5e4f566c&"
import script from "./Generated.vue?vue&type=script&lang=ts&"
export * from "./Generated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports